import React from "react";
import i18n from "../../../i18n/i18n";
import PriceForm from "../priceForm/priceForm";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {RouteParamsModel} from "../../../common/models/routeParams";
import {observer} from "mobx-react";

class ModifyPrice extends React.Component <RouteComponentProps> {
    public render(): JSX.Element {
        const params = this.props.match.params as RouteParamsModel;

        return (
            <div className="add-price content">
                <div className="header">
                    {i18n.t("timetable.actions.modifyAction.header")}
                </div>
                <div>
                    <PriceForm isUpdate={true} priceId={params.id}/>
                </div>
            </div>
        );
    }
}

export default withRouter(observer(ModifyPrice));